import React from "react";
import PropTypes from "prop-types";
import { reduxForm } from "redux-form";
import { compose, withProps } from "recompose";
import { validateForm } from "./validation";
import GEHDMOREDEP2018 from "./GEHDMOREDEP2018";
import GEHD201808 from "./GEHD201808";

const hdfForms = {
  GEHDMOREDEP2018,
  GEHD201808,
};

const enhance = compose(
  withProps(({ hdfId }) => ({ form: hdfId })),
  reduxForm({
    enableReinitialize: true,
    validate: validateForm,
  })
);

const Form = ({ children, ...props }) => {
  const {
    hdfId,
    data,
    submitting,
    submitFailed,
    handleSubmit,
    confirm,
    onSave,
    onClose,
    onPrint,
  } = props;
  const isReadOnly = data.CompletedOn && !!data.CompletedOn.fieldValue;
  const GEForm = hdfForms[hdfId];
  return (
    <form onSubmit={handleSubmit(confirm)}>
      <GEForm
        isReadOnly={isReadOnly}
        data={data}
        submitting={submitting}
        submitFailed={submitFailed}
        onSave={onSave}
        onClose={onClose}
        onPrint={onPrint}
      />
    </form>
  );
};

Form.propTypes = {
  children: PropTypes.func,
  hdfId: PropTypes.string,
  confirm: PropTypes.func,
  handleSubmit: PropTypes.func,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
  onPrint: PropTypes.func,
  submitting: PropTypes.bool,
  submitFailed: PropTypes.bool,
  data: PropTypes.shape({
    CompletedOn: PropTypes.object,
  }),
};
export default enhance(Form);



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/Ge/index.js